<template>
    <main-layout-content :breadcrumbs="pageBreadcrumbs">
        <template #right-side>
            <common-button
                type="primary"
                size="tiny-micro"
                :isSubmittable="false"
                :label="$t('pages.company.my_companies.buttons.create_company')"
                @click="goToPage"
            ></common-button>
        </template>

        <template #content>
            <div>
                <common-page-plain>
                    <common-grid-items>
                        <company-card
                            v-for="companyUser in $auth.getUser().companyUsers"
                            :key="companyUser.company.id"
                            :company="companyUser.company"
                        ></company-card>
                        <div v-if="!$auth.getUser().companyUsers.length" class="my-companies__message">
                            <p>{{ $t('pages.company.my_companies.no_companies') }}</p>
                        </div>
                    </common-grid-items>
                </common-page-plain>
                <profile-not-completed-modal
                    :isModalOpen="isProfileNotCompletedModalOpen"
                    @close-complete-profile-modal="closeProfileNotCompletedModal"
                ></profile-not-completed-modal>
            </div>
        </template>
    </main-layout-content>
</template>

<script>
    import MainLayoutContent from 'components/layouts/layout-content/MainLayoutContent'
    import CompanyCard from 'components/page-elements/company/CompanyCard'
    import RoutesEnum from 'enums/routes.enum'
    import ProfileNotCompletedModal from 'components/modals/user/ProfileNotCompletedModal'

    export default {
        components: { MainLayoutContent, CompanyCard, ProfileNotCompletedModal },

        data() {
            return {
                isProfileNotCompletedModalOpen: false,
            }
        },

        computed: {
            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.company.my_companies.breadcrumbs.my_companies'),
                    },
                ]
            },
        },

        methods: {
            closeProfileNotCompletedModal() {
                this.isProfileNotCompletedModalOpen = false
            },

            goToPage() {
                if (!this.$auth.isUserCompleteProfile()) {
                    this.isProfileNotCompletedModalOpen = true
                } else {
                    this.$router.push({ name: RoutesEnum.COMPANY.CREATE })
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .my-companies__message {
        width: max-content;
    }
</style>
